<ng-container *ngIf="transactions$ | async as transactions; else null">
  <div *ngFor="let day of transactions | keyvalue : keepOrder">
    <h5 class="transaction-date mt-4 mb-2">{{ day.key }}</h5>
    <div class="mb-0 mb-lg-3">
      <div class="card my-2" *ngFor="let transaction of day.value">
        <div class="row">
          <div class="col-8 text-left">
            <div class="fw-bold transaction-text">
              {{ transaction.TransactionDescription }}
            </div>

            <div class="transaction-subtext fw-bold mt-1">
              {{ transaction.TransactionDateUTC | UtcToLocaltimePipe : 'hh:mm a' | uppercase }}
            </div>
          </div>
          <div class="col-4 text-end d-flex align-items-center justify-content-end">
            <div
              class="fw-bold transaction-text text-capitalize"
              [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
            >
              {{ transaction.Amount >= 0 ? '+' : ''
              }}{{ transaction.Amount | FortressCurrencyPipe : (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="(!transactions || !hasTransactions) && transactionType === transactionTypes.loyalty">
    <div class="no-items w-100 text-center border rounded pt-5 pb-4 mt-4 bg-white">
      <div
        class="svg svg-info vs-svg ms-auto me-auto"
        fgbAnimateSvg
        [inlineSVG]="'assets/images/placeholders/Activity.svg'"
      ></div>
      <p class="text-black text-center font-size-14 mt-2 mb-0">
        {{ 'account.activity.placeholder.history.description' | translate }}
      </p>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      (!transactions || !hasTransactions) &&
      (transactionType === transactionTypes.ecash || transactionType === transactionTypes.payment)
    "
  >
    <div class="no-items w-100 text-center border rounded pt-5 pb-4 mt-4 bg-white">
      <div
        class="svg svg-info vs-svg ms-auto me-auto"
        fgbAnimateSvg
        [inlineSVG]="'assets/images/placeholders/Activity.svg'"
      ></div>
      <p class="text-black text-center font-size-14 mt-2 mb-0">{{ 'no.transaction.message' | translate }}</p>
    </div>
  </ng-container>
</ng-container>

<div *ngIf="loading" class="mt-4">
  <fgb-loading></fgb-loading>
</div>
